import React, { useEffect, useState } from 'react'
import Button from "reactstrap/es/Button"
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { Select, Popconfirm, message, Modal as ModalAntd, Input } from 'antd'
import '../../../assets/scss/views/_BulkCombineLabels.scss'
import { requestPhotoByOrder, requestPhotoByPackages } from '../../../services/api/EntranceServices'
import Promise from 'bluebird'

const { TextArea } = Input

function BulkRequestPhoto(props) {
    const { resetBulkAll, reloadItems, closeMenu, items = [], selectedItems = [] } = { ...props }
    const [isOpen, setIsOpen] = useState(false)
    const [listItems, setListItems] = useState([])
    const [itemsSuccess, setItemsSuccess] = useState([])
    const [loading, setLoading] = useState(false)
    const [itemLoading, setItemLoading] = useState('')
    const [itemError, setItemError] = useState([])
    const [isDescriptionOpen, setIsDescriptionOpen] = useState(false)
    const [description, setDescription] = useState('')

    const _genListItems = () => {
        const listItems = items.filter(item => selectedItems.includes(item._id))
        setListItems(listItems)
    }

    useEffect(() => {
        _genListItems()
    }, [items, selectedItems])

    const _handleToggleModal = () => {
        setIsOpen(!isOpen)
        if (isOpen) {
            setDescription('')
            resetBulkAll()
            closeMenu()
            reloadItems()
        }
    }

    const _genAllItems = () => {
        _onRequestPhoto(listItems)
    }

    const _onRequestPhoto = async (listItems) => {
        setItemsSuccess([])
        setItemError([])
        setItemLoading('')

        let successCount = 0
        let errorCount = 0
        const total = listItems.length

        await Promise.each(listItems, async (item) => {
            setItemLoading(item._id)
            try {
                // Hiện tại không request photo đơn import do packageName = ""
                if (['import'].includes(item.source)) throw new Error(`Request Chụp ảnh không áp dụng với đơn import`)
                if (['labelled', 'packaged', 'cancelled'].includes(item.production_status)) throw new Error(`Request Chụp ảnh không áp dụng với đơn ${item.production_status}`)

                const payload = {
                    source: 'MCVN', //1C, MCVN, TCVN, FFM
                }
                const packageInfo = {}
                if (item.packageName) packageInfo.name = item.packageName
                if (item.storename) packageInfo.namespace = item.storename
                if (!!Object.keys(packageInfo).length) payload.packages = [packageInfo]
                if (description) payload.note = description

                const { success, message: mess } = await requestPhotoByPackages(payload)
                if (!success) throw new Error(mess)
                successCount++
                setItemsSuccess(prev => [...new Set([...prev, item._id])])
            } catch (e) {
                errorCount++
                setItemError(prev => {
                    if (prev.find(x => x._id === item._id)) return prev
                    return [...prev, { _id: item._id, message: e.message }]
                })
            }
            if (successCount + errorCount === total) {
                setItemLoading('')
            } else {
                setItemLoading(item._id)
            }
        })
    }

    const handleOk = (e) => {
        e.preventDefault()
        setIsDescriptionOpen(true)
    }

    const _handleConfirmDescription = async () => {
        setIsDescriptionOpen(false)
        setLoading(true)
        await _genAllItems()
        setLoading(false)
    }

    const _handleCancelDescription = () => {
        setIsDescriptionOpen(false)
    }

    const _genIcon = (item) => {
        if (itemsSuccess.includes(item._id)) return <i className="icon-check text-success" />

        if (itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemError.find(itemErr => item._id === itemErr._id).message) return <i className="icon-cross text-danger" />

        return <i className="icon-spinner6 spinner-reverse text-dark" />
    }

    const _changeItemRequest = async (item) => {
        try {
            // Hiện tại không request photo đơn import do packageName = ""
            if (['import'].includes(item.source)) throw new Error(`Request Chụp ảnh không áp dụng với đơn import`)
            if (['labelled', 'packaged', 'cancelled'].includes(item.production_status)) throw new Error(`Request Chụp ảnh không áp dụng với đơn ${item.production_status}`)

            const payload = {
                source: 'MCVN', //1C, MCVN, TCVN, FFM
            }
            const packageInfo = {}
            if (item.packageName) packageInfo.name = item.packageName
            if (item.storename) packageInfo.namespace = item.storename
            if (!!Object.keys(packageInfo).length) payload.packages = [packageInfo]
            if (description) payload.note = description
            const { success, message: mess } = await requestPhotoByPackages(payload)

            if (!success) {
                throw new Error(mess)
            }
            setItemsSuccess(prev => [...new Set([...prev, item._id])])
            setItemError(prev => prev.filter(errItem => errItem._id !== item._id))
            setItemLoading('')
        } catch (e) {
            setItemError(prev => prev.map(errItem =>
                errItem._id === item._id
                    ? { ...errItem, message: e.message }
                    : errItem
            ))
            setItemLoading('')
        }
    }

    const _handleClickRetryItem = async (item) => {
        const newItemsStatus = itemError.map(item2 => {
            if (item2._id === item._id) {
                return {
                    ...item2,
                    message: ''
                }
            } else {
                return item2
            }
        })
        setItemError(newItemsStatus)
        setItemLoading(item._id)

        _changeItemRequest(item)
    }

    const _retryAll = async (listError) => {
        setLoading(true)
        await _onRequestPhoto(listError)
        setLoading(false)
    }

    const _showMessage = (itemError, itemsSuccess, _id) => {
        if (itemError.find(itemErr => _id === itemErr._id) !== undefined) {
            if (itemError.find(itemErr => _id === itemErr._id).message) {
                return (
                    <span className="d-sm-block text-danger">{
                        itemError.find(itemErr => _id === itemErr._id).message
                    }</span>
                )
            } else {
                return (
                    <span className="d-sm-block">Loading...</span>
                )
            }
        } else if (itemsSuccess.includes(_id)) {
            return (
                <span className="d-sm-block text-success">Request chụp ảnh thành công!</span>
            )
        } else {
            return (
                <span className="d-sm-block">Waiting...</span>
            )
        }
    }

    const disabledBulkAction = listItems.some(i =>
        (Array.isArray(i.tags) && i.tags.find(x => ['photo_requested', 'photo_updated'].includes(x)))
        || ['labelled', 'packaged', 'cancelled'].includes(i.production_status)
    )

    return (
        <div className='BulkRequestPhoto'>
            <Button color="link" onClick={_handleToggleModal} disabled={disabledBulkAction} className="mr-1">Request photo</Button>
            {isOpen && (
                <Modal isOpen={isOpen} className="BulkChangeStatus BulkHoldShip"
                >
                    <ModalHeader>
                        Request chụp ảnh
                    </ModalHeader>
                    <ModalBody>
                        {listItems.length > 0 && (
                            <div className="ModalContent">
                                <h6 className='list-title d-block mb-2'>
                                    Có <span className='font-weight-bold'>{listItems.length || 0}</span> đơn hàng cần request chụp ảnh:
                                    {!!itemError.length &&
                                        <span className='mx-2'><span className='text-danger'>Lỗi:</span> {itemError.length} đơn</span>
                                    }
                                    {!!itemsSuccess.length &&
                                        <span className='mx-2'><span className='text-success'>Thành công:</span> {itemsSuccess.length} đơn</span>
                                    }
                                </h6>
                                <div className="listItems" style={{ maxHeight: 500, overflowY: 'auto' }}>
                                    {
                                        listItems.map(item => {
                                            return (
                                                <div key={item._id} className="ItemChangeStatus d-sm-flex mb-2 pb-2">
                                                    <div className="IconStatus mr-2">
                                                        {_genIcon(item)}
                                                    </div>
                                                    <div className="ContentChangeStatus">
                                                        <strong>{item.packageName}</strong> - orderID: #{item.barcodeNumber}
                                                        {
                                                            (itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemLoading !== item._id) && (
                                                                <span
                                                                    onClick={() => _handleClickRetryItem(item)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    <i className="icon-spinner11 text-danger ml-2" />
                                                                </span>
                                                            )
                                                        }
                                                        {itemLoading === item._id && <i className='icon-spinner2 spinner ml-2' />}
                                                        {_showMessage(itemError, itemsSuccess, item._id)}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <div className="d-sm-flex">
                            <Button disabled={loading || itemLoading !== ''} onClick={_handleToggleModal} className="bg-grey ml-2">
                                Đóng
                            </Button>
                            <Button disabled={loading || itemLoading !== '' || itemsSuccess.length === listItems.length} onClick={handleOk} className="bg-primary ml-2">
                                Ok
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            )}
            <ModalAntd
                title="Photo request description"
                visible={isDescriptionOpen}
                onOk={_handleConfirmDescription}
                onCancel={_handleCancelDescription}
                okText="Confirm"
                cancelText="Cancel"
                destroyOnClose
                zIndex={1100}
                width={900}
            >
                <TextArea
                    placeholder="Descript your request..."
                    rows={8}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
            </ModalAntd>
        </div>
    )
}

export default BulkRequestPhoto